export default __webpack_public_path__ + "static/media/nurse.3527c000.png";